const video = [
  {
    title: "綠能運輸願景，車用半導體市場與技術變革趨勢",
    thumbnail: require("assets/images/home/video-thumbnails/1.jpg"),
    src: "https://www.youtube.com/embed/vuCS2oE9DdA",
  },
  {
    title: "我國民眾淨零永續行為調查",
    thumbnail: require("assets/images/home/video-thumbnails/2.jpg"),
    src: "https://www.youtube.com/embed/iTFsi-IZCl4",
  },
  {
    title: "淨零永續趨勢下之再生能源",
    thumbnail: require("assets/images/home/video-thumbnails/3.jpg"),
    src: "https://www.youtube.com/embed/VZgnmDjlYV0",
  },
  {
    title: "IEKCQM2022年台灣製造業",
    thumbnail: require("assets/images/home/video-thumbnails/4.jpg"),
    src: "https://www.youtube.com/embed/gfTgEzOoVlY",
  },
  {
    title: "永續與綠色能源",
    thumbnail: require("assets/images/home/video-thumbnails/5.jpg"),
    src: "https://www.youtube.com/embed/CZc-7_VkIeQ",
  },
  {
    title: "永續新興產業",
    thumbnail: require("assets/images/home/video-thumbnails/6.jpg"),
    src: "https://www.youtube.com/embed/FEPkFhk0mXM",
  },
  {
    title: "晉升綠色新貴人才",
    thumbnail: require("assets/images/home/video-thumbnails/7.jpg"),
    src: "https://www.youtube.com/embed/fTpUPn15OWo",
  },
  {
    title: "我的電動車",
    thumbnail: require("assets/images/home/video-thumbnails/8.jpg"),
    src: "https://www.youtube.com/embed/yJ3M4ApCeto",
  },
  {
    title: "究好豬碳足跡",
    thumbnail: require("assets/images/home/video-thumbnails/9.jpg"),
    src: "https://www.youtube.com/embed/G3zYJJD3wrE",
  },
  {
    title: "電動車電池─低碳行動即刻出發",
    thumbnail: require("assets/images/home/video-thumbnails/10.jpg"),
    src: "https://www.youtube.com/embed/UreFQJ2DfWw",
  },
  {
    title: "海廢變身低碳鍵盤滑鼠",
    thumbnail: require("assets/images/home/video-thumbnails/11.jpg"),
    src: "https://www.youtube.com/embed/GV9ka8HOhzw",
  },
  {
    title: "碳中和建築",
    thumbnail: require("assets/images/home/video-thumbnails/12.jpg"),
    src: "https://www.youtube.com/embed/LF4F51KfaAo",
  },
  {
    title: "紡織碳足跡 – 衣筆勾銷",
    thumbnail: require("assets/images/home/video-thumbnails/13.jpg"),
    src: "https://www.youtube.com/embed/d3JKBisojok",
  },
  {
    title: "用科學選擇你的減碳生活",
    thumbnail: require("assets/images/home/video-thumbnails/14.jpg"),
    src: "https://www.youtube.com/embed/udlow0f5TxE",
  },
  {
    title:
      "眺望2026系列｜從挑戰到商機：算力時代下驅動的電網與儲能新局-黃雅琪 E2",
    thumbnail: require("assets/images/home/video-thumbnails/15.jpg"),
    src: "https://www.youtube.com/embed/9B_RUB67CR8?si=1F6T8gK0Pzt8BsTg",
  },
  {
    title: "眺望2026系列｜AI建設擴大下的能源產業新機會與挑戰-王孟傑 E2",
    thumbnail: require("assets/images/home/video-thumbnails/16.jpg"),
    src: "https://www.youtube.com/embed/MawI5oOYkHY?si=yghspW13IMnZfvP_",
  },
  {
    title: "臺灣產業導入碳捕捉分離、封存與再利用技術的機會與挑戰-陳育誠",
    thumbnail: require("assets/images/home/video-thumbnails/17.jpg"),
    src: "https://www.youtube.com/embed/DxyEvHiW0z0?si=1vYBhXgtQSo_Rx8N",
  },
  {
    title: "全球BECCS的發展現況與展望-陳明君",
    thumbnail: require("assets/images/home/video-thumbnails/18.jpg"),
    src: "https://www.youtube.com/embed/il58SwEUMWI?si=1rEEpaogWsFS_4AH",
  },
  {
    title: "重塑供能版圖：全球低碳氫氣市場與產業趨勢-黃霈瑜",
    thumbnail: require("assets/images/home/video-thumbnails/19.jpg"),
    src: "https://www.youtube.com/embed/juUl2KxDE1A?si=-mEXr2Z6_55O-O0c",
  },
  {
    title: "駛向零碳未來：氫基燃料在陸海空載具產業的全球佈局與關鍵拐點-石蕙菱",
    thumbnail: require("assets/images/home/video-thumbnails/20.jpg"),
    src: "https://www.youtube.com/embed/LaDf78iIUKc?si=NoXgg_d_1mkhGs0L",
  },
];

export default video;
